export const EnablePPQConsentLoop = "EnablePPQConsentLoop"; // #93877

export const EnablePPQAutomation = "EnablePPQAutomation"; // #98947

export const EnableEnhancedInsufficientInformationFunctionality = "EnableEnhancedInsufficientInformationFunctionality"; // #107200

export const HealthSurveillanceCrBugs = "HealthSurveillanceCrBugs"; // #108563

export const EnableMuiMigration = "EnableMuiMigration"; // #103459

export const EnableBookAppointmentsPageImprovements = "EnableBookAppointmentsPageImprovements"; // #110800

export const EnableHSConsultationDataDownloadImprovements = "EnableHSConsultationDataDownloadImprovements"; // #110308

export const EnforceMandatoryNotesForInsufficientInfoTasks = "EnforceMandatoryNotesForInsufficientInfoTasks"; // #110308

export const EnableHealthSurveillanceCrs11_3 = "EnableHealthSurveillanceCrs11_3"; // 110958

export const GenericChangeRequests = "GenericChangeRequests"; // #110970

export const UpdateImmsClearCertificateAddress = "UpdateImmsClearCertificateAddress"; // 111785

export const UseAppInsightsConnectionString = "UseAppInsightsConnectionString"; // #111286

export const DiaryBlockingImprovements = "DiaryBlockingImprovements"; // #112056

export const ReferralSupportingDocumentImprovements = "ReferralSupportingDocumentImprovements"; // #110913

export const HSCaseAutomationForNightWorker = "HSCaseAutomationForNightWorker"; // #107161

export const EnableNewNightWorkerQuestions = "EnableNewNightWorkerQuestions"; // #110733

export const CanSubmitFormWhenOrgLevelsAreDisabled = "CanSubmitFormWhenOrgLevelsAreDisabled"; // #113181

export const CaseConversationImprovements = "CaseConversationImprovements"; // #110900

export const EnableAppointmentDNAFix = "EnableAppointmentDNAFix"; // #110264

export const DiariesRevampPart1 = "DiariesRevampPart1"; // #112614

export const PartialMatchImprovements = "PartialMatchImprovements"; // #112502

export const CrBugs11_5 = "CrBugs11_5"; // #112416

export const ExtendNoContactCaseClosure = "ExtendNoContactCaseClosure"; // #112579

export const MoreSectionsForGenericForm = "MoreSectionsForGenericForm"; // #113957

export const EnableEmployeeAuditLogs = "EnableEmployeeAuditLogs"; // #112525

export const ShowClinicalNotesOnImmunisationRecord = "ShowClinicalNotesOnImmunisationRecord"; // #114536

export const CustomerLevelPartialMatchChanges = "CustomerLevelPartialMatchChanges"; // #114709

export const EPPCloseMonitoring = "EPPCloseMonitoring"; // #115036

export const UseV4ClinicalNotesAndReferralReports = "UseV4ClinicalNotesAndReferralReports"; // #115126

export const ImmunisationWorkflowImprovementsPt1 = "ImmunisationWorkflowImprovementsPt1"; // #114902

export const OHBGPSpecialistLetterChanges = "OHBGPSpecialistLetterChanges"; // #117598

export const EnableSNCAndFinanceInfoFunctionality = "EnableSNCAndFinanceInfoFunctionality"; // #114846

export const ManageFeatureToggles = "ManageFeatureToggles"; // #114874

export const PreventPPQClinicalNotesDuplicateSubmission = "PreventPPQClinicalNotesDuplicateSubmission"; // #115094

export const CaseConversationDocumentText = "CaseConversationDocumentText"; // #114225

export const PreventDoubleClickOnAuditReportSubmission = "PreventDoubleClickOnAuditReportSubmission"; // #114279
